module.exports = __webpack_public_path__ + "img/hand.cbbb94e9.svg";